/* istanbul ignore file */
import { Dropdown, useDropdownHelper, DefaultDropdownProps } from 'framework/form';

interface EnumDropdownProps extends Omit<DefaultDropdownProps, 'options'> {
  options: Dictionary<string>;
}

const ENGLISH_LEVEL_OPTIONS = {
  BEGINNER: 'Beginner',
  ELEMENTARY: 'Elementary',
  INTERMEDIATE: 'Intermediate',
  'UPPER INTERMEDIATE': 'Upper Intermediate',
  ADVANCED: 'Advanced',
  PROFICIENCY: 'Proficiency',
};

const MinimalAndBetterEnglishLevelEnumDropdown = ({ ...props }: Omit<EnumDropdownProps, 'options'>) => {
  const { getSource, getRawOnChangeCallback } = useDropdownHelper(props);
  const rawOnChangeCallback = getRawOnChangeCallback() || (() => {});
  const englishLevelValues = Object.keys(ENGLISH_LEVEL_OPTIONS);

  const onChangeCallback = (values: any) => {
    const source = getSource();
    const selectedValues = values[source];
    const lowestSelected = englishLevelValues.find((option: string) => selectedValues?.includes(option));

    if (lowestSelected) {
      const greaterThanSelected: string[] = englishLevelValues.slice(englishLevelValues.indexOf(lowestSelected));

      rawOnChangeCallback({
        [source]: greaterThanSelected,
      });
    }
  };

  return (
    <Dropdown
      {...props}
      options={englishLevelValues.map(key => ({
        value: key,
        label: ENGLISH_LEVEL_OPTIONS[key as keyof typeof ENGLISH_LEVEL_OPTIONS],
      }))}
      onChangeCallback={onChangeCallback}
    />
  );
};

export default MinimalAndBetterEnglishLevelEnumDropdown;
